<template>
  <div class="content-body">
    <div class="top-font">数据说明：1. 账户余额实时更新，数据仅供参考。账户消耗会有20分钟延迟。</div>
    <div class="count-body">
      <div class="one-count">
        <div class="icon"><img src="../../assets/images/icon_today_use.png" alt="use"></div>
        <div class="right-body">
          <p class="num" v-text="data.today_pay"></p>
          <p class="font">今日消耗</p>
        </div>
      </div>
      <div class="one-count">
        <div class="icon"><img src="../../assets/images/icon_balance.png" alt="use"></div>
        <div class="right-body">
          <p class="num" v-text="data.company_balance"></p>
          <p class="font">账号余额</p>
        </div>
      </div>
      <div class="one-count">
        <div class="icon"><img src="../../assets/images/icon_balance.png" alt="use"></div>
        <div class="right-body count-z">
          <div class="count"><span>待审核</span><span class="n" v-text="data.handle_adv"></span></div>
          <div class="count"><span>投放中</span><span class="n" v-text="data.action_adv"></span></div>
          <div class="count"><span>未启动</span><span class="n" v-text="data.fre_adv"></span></div>
        </div>
      </div>
    </div>
    <div class="line-body"></div>
    <div class="condtion">
      <el-form ref="form" :inline="true" :model="form" label-width="60px" label-position="left" size="small">
        <el-form-item label="时间:">
          <el-select v-model="form.dateType" placeholder="请选择活动区域" style="width: 140px;">
            <el-option label="今天" value="1"></el-option>
            <el-option label="过去一天" value="2"></el-option>
            <el-option label="过去七天" value="3"></el-option>
            <el-option label="过去一个月" value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="广告主:">
          <el-select v-model="form.type" placeholder="请选择活动区域">
            <el-option label="不限" value=""></el-option>
            <el-option :label="company_name" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getCountLists">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="table">
      <el-table :data="tableData" border style="width: 100%" :header-cell-style="{ 'background-color': '#F4F4F4', 'font-weight': 'bold', 'color': '#333' }">
          <el-table-column prop="today" label="时间" width="180" align="center"></el-table-column>
          <el-table-column label="广告主" width="180" align="center">
            <template>
              {{ company_name }}
            </template>
          </el-table-column>
          <el-table-column prop="read_num" label="曝光量" align="center"></el-table-column>
          <el-table-column prop="look_num" label="点击量" align="center"></el-table-column>
          <el-table-column prop="click_l" label="点击率" align="center"></el-table-column>
          <el-table-column prop="cpc" label="cpc" align="center"></el-table-column>
          <el-table-column prop="cpm" label="cpm" align="center"></el-table-column>
          <el-table-column prop="pay_money" label="消耗金额" align="center"></el-table-column>
        </el-table>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: 'index',
  data() {
    return {
      form: {
        dateType: '1',
        type: ''
      },
      curentComponents: 'PlanView',
      tableData: [],
      dialogVisible: false,
      company_name: '',
      data: []
    };
  },
  mounted() {
    document.title = '首页';
    this.$http.post('/trader/index/getIndexInfo').then(res => {
      if (res.code === 200) {
        this.data = res.data;
        this.getCountLists();
      }
    });
  },
  methods: {
    getCountLists() {
      this.$http.post('/trader/index/getCountLists', this.form).then(res => {
        if (res.code === 200) {
          this.tableData = res.data;
          this.$function.hiddenLoading();
          this.company_name = sessionStorage.getItem('user_info') ? JSON.parse(sessionStorage.getItem('user_info'))['company_name'] : '';
        }
      });
    },
    getForm(time) {
      return this.$function.formatDate(time, 'MM-dd');
    }
  },
  watch: {
    checked(newVal) {
      this.input = parseInt(newVal) ? 99999999 : 0;
    }
  }
};
</script>
<style lang="less" scoped="">
  .content-body {
    height: calc(100% - 46px);
    width: calc(100% - 62px);
		padding: 23px 31px;
    color: #b4b4b4;
    font-size: 12px;
    .count-body {
      display: flex;
      margin-top: 21px;
      .one-count {
        width: 310px;
        display: flex;
        align-items: center;
        .icon {
          width: 100px;
          height: 70px;
          display: flex;
          align-items: center;
          justify-content: center;
          border: solid 1px #f5f5f5;
          margin-right: 21px;
        }
        .num {
          color: #333;
          font-size: 24px;
          font-weight: 700;
          margin-bottom: 10px;
        }
        .font {
          color: #999;
          font-size: 14px;
        }
        .count-z {
          display: flex;
          flex-wrap: wrap;
        }
        .count {
          display: flex;
          align-items: center;
          margin-bottom: 5px;
          span {
             color: #999;
             font-size: 14px;
          }
          .n {
            color: #333;
            font-size: 24px;
            font-weight: 700;
            width: 50px;
            text-align: center;
          }
        }
      }
    }

    .line-body {
      height: 5px;
      background: #F5F5F5;
      margin: 31px 0;
    }
    .table {
      margin-top: 10px;
    }
	}


</style>
